import clsx from 'clsx'
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {ActivityDrawer, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
//import {Sidebar} from './components/Sidebar'
import {ThemeModeProvider} from '../partials/layout/theme-mode/ThemeModeProvider'
import {useModule} from '../../app/platform/modules'
import {ModuleRail} from './components/modern/ModuleRail'

const MasterLayout = () => {
  const {isModuleSession} = useModule()
  const modernShellEnabled = process.env.REACT_APP_MODERN_SHELL_ENABLED !== 'false'
  const appTitle = process.env.REACT_APP_TITLE?.toLowerCase()
  const isMenulessPortal =
    !isModuleSession && (appTitle === 'dsos' || appTitle === 'student-clearance')
  const pageClasses = clsx('page d-flex flex-column-fluid', {
    'flex-row': !isMenulessPortal,
    'flex-column flex-lg-row': isMenulessPortal,
  })
  const location = useLocation()

  useEffect(() => {
    const {body} = document
    body.classList.toggle('nosi-modern-shell', modernShellEnabled)
    body.classList.toggle('nosi-module-shell', modernShellEnabled && isModuleSession)
    body.classList.toggle('nosi-legacy-shell', modernShellEnabled && !isModuleSession)

    return () => {
      body.classList.remove('nosi-modern-shell', 'nosi-module-shell', 'nosi-legacy-shell')
    }
  }, [isModuleSession, modernShellEnabled])
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div
          id='nosi_app_shell'
          className={clsx('d-flex flex-column flex-root nosi-app-shell', {
            'nosi-app-shell--module': isModuleSession,
            'nosi-app-shell--legacy': !isModuleSession,
          })}
        >
          <div className={pageClasses}>
            {modernShellEnabled && isModuleSession && <ModuleRail />}
            <AsideDefault hideMenuContent={isMenulessPortal} />
            <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
              <HeaderWrapper />

              <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                <Content>
                  <Outlet />
                </Content>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        <RightToolbar />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
